import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    contentContainer: {
        marginTop: "15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "0 150px",
        "@media (max-width: 620px)": {
            padding: "0 20px 0 0",
        },
        "@media (min-width: 621px) and (max-width: 1470px)": {
            padding: "0 50px",
        },
    },
    inputTextField: {
        maxWidth: 460,
        minWidth: 220,
    },
    buttonBox: {
        width: "250px",
        textAlign: "left",
    },
    infoContainer: {
        marginTop: "20px",
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        "@media (max-width: 620px)": {
            flexDirection: "column",
        },
    },
}));
